import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  activeMember,
  createMember,
  deleteMember,
  getMember,
  inactiveMember,
  listMember,
  updateMember,
} from 'api/setting/member.api';
import {
  ActiveMemberRequestModel,
  DeleteMemberRequestModel,
  GetMemberRequestModel,
  InactiveMemberRequestModel,
  ListMemberRequestModel,
  SaveMemberRequestModel,
} from 'models/setting/member.model';

export const getMemberAction = createAsyncThunk(
  'GET_MEMBER_REQUEST',
  async (payload: GetMemberRequestModel) => getMember(payload),
);

export const listMemberAction = createAsyncThunk(
  'LIST_MEMBER_REQUEST',
  async (payload: ListMemberRequestModel) => listMember(payload),
);

export const createMemberAction = createAsyncThunk(
  'CREATE_MEMBER_REQUEST',
  async (payload: SaveMemberRequestModel, { rejectWithValue }) => {
    try {
      return await createMember(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);

export const updateMemberAction = createAsyncThunk(
  'UPDATE_MEMBER_REQUEST',
  async (payload: SaveMemberRequestModel, { rejectWithValue }) => {
    try {
      return await updateMember(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);

export const deleteMemberAction = createAsyncThunk(
  'DELETE_MEMBER_REQUEST',
  async (payload: DeleteMemberRequestModel, { rejectWithValue }) => {
    try {
      return await deleteMember(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);

export const inactiveMemberAction = createAsyncThunk(
  'INACTIVE_MEMBER_REQUEST',
  async (payload: InactiveMemberRequestModel, { rejectWithValue }) => {
    try {
      return await inactiveMember(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);

export const activeMemberAction = createAsyncThunk(
  'ACTIVE_MEMBER_REQUEST',
  async (payload: ActiveMemberRequestModel, { rejectWithValue }) => {
    try {
      return await activeMember(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);
